<template>
  <div class="modelPageWrap mainPageBg">
    <img :src="img" alt="" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      img: "",
    };
  },
  watch: {
    $route() {
      this.getImg();
    },
  },
  methods: {
    getImg() {
      if (this.$route.path == "/modelPage") {
        this.img = require("@/assets/images/xitong/xitong.jpg");
      } else if (this.$route.path == "/liftmModelPage") {
        this.img = require("@/assets/images/xitong/image1.png");
      }
    },
  },
  created() {
    this.getImg();
  },
};
</script>

<style lang="scss" scoped>
.modelPageWrap {
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 90%;
    height: 90%;
  }
}
</style>